import { createContext } from 'react';
import { OFFICE_TABLE_NAME_COL } from '../i18n/keyConstants';
import moment from 'moment';

export const initialState = {
    offices: [],
    filters: [],
    defaultFilters: [],
    hiddenColumns: [],
    columnName: moment()
        .subtract(1, 'month')
        .format('YYYYMM'),
    tableSize: 0,
    direction: 'desc',
    pageSize: 25,
    currentPage: 1,
    sortInfo: {},
    isLoading: true,
    error: null,
    columns: [{ title: OFFICE_TABLE_NAME_COL, name: 'name' }],
    columnOrder: [],
    firstInvoiceMonth: null,
    integratedSortingColumnExtensions: [],
    FTECheckboxVal: false,
    FTEValList: null,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                offices: action.offices,
                tableSize: action.totalRows,
                isLoading: false,
                columns: [{ title: OFFICE_TABLE_NAME_COL, name: 'name' }, ...action.columns],
                columnOrder: [action.columnOrder],
                hiddenColumns: action.hiddenColumns,
                firstInvoiceMonth: action.firstInvoiceMonth,
                integratedSortingColumnExtensions: action.integratedSortingColumnExtensions,
                FTEValList: action.FTEValList,
            };
        case 'FETCH_ERROR':
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case 'SET_ISLOADING_TRUE':
            return {
                ...state,
                isLoading: true,
            };
        case 'SET_ISLOADING_FALSE':
            return {
                ...state,
                isLoading: false,
            };
        case 'FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
            };
        case 'PAGESIZE':
            return {
                ...state,
                pageSize: action.payload,
            };
        case 'HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: action.payload,
            };
        case 'CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload,
            };
        case 'SORT_INFO':
            return {
                ...state,
                sortInfo: action.sortInfo,
                columnName: action.columnName,
                direction: action.direction,
            };
        case 'UPDATE_CHECKBOX':
            return {
                ...state,
                FTECheckboxVal: action.payload,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
